import React, { useState } from 'react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { CoreButton, CoreTextField } from 'src/components/core'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import URLs from 'src/api/url'
const EmbedViewCourse = props => {
  const { classes } = props
  const [copiedEmbedCode, setCopiedEmbedCode] = React.useState(false)
  const [copiedEmbedCode2, setCopiedEmbedCode2] = React.useState(false)
  const entity = useSelector(state => state.course.course)
  const [showShareButtons, setShowShareButtons] = useState(0)

  let shareCode = showShareButtons ? '?shr=1' : ''

  const onClickEmbedCode = () => {
    setCopiedEmbedCode(true)
    setTimeout(() => {
      setCopiedEmbedCode(false)
    }, 500)
  }
  const onClickEmbedCode2 = () => {
    setCopiedEmbedCode2(true)

    setTimeout(() => {
      setCopiedEmbedCode2(false)
    }, 500)
  }
  return (
    <div className={classes.customDomain__root}>
      <Typography fontSize={'14px'} fontWeight={400} fontFamily={'Inter'}>
        You can embed the mini course on your website with JavaScript code.
      </Typography>
      <Typography fontSize={'14px'} fontWeight={400} fontFamily={'Inter'}>
        Add the following codes to the{' '}
        <span
          style={{
            color: '#015ffb',
          }}
        >
          {'<head>'}
        </span>{' '}
        tag of your site.
      </Typography>
      <CoreTextField
        fullWidth
        marginTop={false}
        value={
          '<meta http-equiv="Access-Control-Allow-Origin" content="' +
          URLs.APP_URL +
          '" />' +
          '<script src="' +
          URLs.APP_URL +
          'viewer.js"></script>' +
          '<script>' +
          'const app = new MiniCourse();' +
          'document.addEventListener("DOMContentLoaded", function () {' +
          'app.init({code: "' +
          entity.code +
          '", share: ' +
          (shareCode ? 'true' : 'false') +
          '});' +
          '});' +
          '</script>'
        }
      />

      <CopyToClipboard
        text={
          '<meta http-equiv="Access-Control-Allow-Origin" content="' +
          URLs.APP_URL +
          '" />' +
          '<script src="' +
          URLs.APP_URL +
          'viewer.js"></script>' +
          '<script>' +
          'const app = new MiniCourse();' +
          'document.addEventListener("DOMContentLoaded", function () {' +
          'app.init({code: "' +
          entity.code +
          '", share: ' +
          (shareCode ? 'true' : 'false') +
          '});' +
          '});' +
          '</script>'
        }
      >
        <CoreButton
          onClick={onClickEmbedCode}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedEmbedCode ? 'Copied!' : 'Copy Code'}
        </CoreButton>
      </CopyToClipboard>

      <Typography
        color={'#002E47'}
        fontSize={'14px'}
        fontWeight={400}
        fontFamily={'Inter'}
      >
        Add the following codes to the{' '}
        <span
          style={{
            color: '#015ffb',
          }}
        >
          {'<body>'}
        </span>{' '}
        tag of your site.
      </Typography>
      <CoreTextField
        fullWidth
        value={'<div id="mcg-form-' + entity.code + '"></div>'}
        marginTop={false}
      />

      <CopyToClipboard text={'<div id="mcg-form-' + entity.code + '"></div>'}>
        <CoreButton
          onClick={onClickEmbedCode2}
          variant="contained"
          color="primary"
          fullWidth
        >
          {copiedEmbedCode2 ? 'Copied!' : 'Copy Code'}
        </CoreButton>
      </CopyToClipboard>
    </div>
  )
}

export default withStyles(styles)(EmbedViewCourse)
